module.exports = __webpack_public_path__ + "static/media/tela-passo-09.fa18a74c.jpg";